import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'superflex-agregar-carrito-btn',
    template: `
        <p-button
            label="{{'BOTONES.btnAgregarCarrito' | translate}}"
            [icon]="icon"
            [styleClass]="styleClass"
            [class]="class"
            (onClick)="onClick.emit()"
            [disabled]="isDisabled">
        </p-button>`,
    host: { 'class': '' },
})
export class AgregarCarritoBtnComponent {

    @Input() isDisabled: boolean
    @Output() onClick = new EventEmitter<any>()
    @Input() icon = '';
    @Input() styleClass = 'p-button-outlined p-mr-2';
    @Input() class = '';

    constructor() {/** */ }
}
